import type { Au06RuleSet } from "./types.js";

// AU-06 ruleset for FY2025-26 (1 July 2025 – 30 June 2026).
//
// From 1 July 2025 the ATO replaced the old "percentage of whole repayment
// income" cliff model with a MARGINAL model: a higher minimum repayment
// threshold ($67,000) and compulsory repayment calculated only on repayment
// income ABOVE each band floor — except the top band, which reverts to a flat
// 10% of WHOLE repayment income (see `wholeIncome` below).
//
// Official 2025-26 compulsory repayment thresholds and rates (verbatim):
//   $0        – $67,000   : Nil
//   $67,001   – $125,000  : 15c for each $1 over $67,000
//   $125,001  – $179,285  : $8,700 plus 17c for each $1 over $125,000
//   $179,286  and over    : 10% of your total repayment income
//
// $8,700 is the accumulated repayment at the $125,000 floor:
//   15% × ($125,000 − $67,000) = 15% × $58,000 = $8,700.  (checked)
//
// Figures transcribed from the ATO study-and-training-loan thresholds table.
// Never edit a shipped ruleset to "fix" a later year — author a new
// fy20XX-XX.ts and register it. These rates index each year with average
// weekly earnings, so re-verify the sources before each FY rollover.
export const fy2025_26: Au06RuleSet = {
  product: "AU06",
  fy: "2025-26",
  effectiveFrom: "2025-07-01",
  effectiveTo: "2026-06-30",
  sources: {
    thresholds:
      "https://www.ato.gov.au/tax-rates-and-codes/study-and-training-support-loans-rates-and-repayment-thresholds",
    whatsNew:
      "https://www.ato.gov.au/individuals-and-families/study-and-training-support-loans/study-and-training-loans-what-s-new",
    repaymentIncome:
      "https://www.ato.gov.au/individuals-and-families/income-deductions-offsets-and-records/income-tests",
    compulsoryRepayments:
      "https://www.ato.gov.au/individuals-and-families/study-and-training-support-loans/compulsory-repayments",
  },
  sourcesVerifiedAt: "2026-06-13",
  minRepaymentThreshold: 67_000,
  bands: [
    // Below the minimum threshold — no compulsory repayment.
    { from: 0, to: 67_001, baseAmount: 0, rate: 0 },
    // 15c per $1 over $67,000. Band covers repayment income $67,001–$125,000.
    { from: 67_001, to: 125_001, baseAmount: 0, rate: 0.15 },
    // $8,700 + 17c per $1 over $125,000. Covers $125,001–$179,285.
    { from: 125_001, to: 179_286, baseAmount: 8_700, rate: 0.17 },
    // Top band: 10% of WHOLE repayment income (not marginal). $179,286+.
    { from: 179_286, to: null, baseAmount: 0, rate: 0.1, wholeIncome: true },
  ],
};
